export default __webpack_public_path__ + "static/media/journeyplanner.a57769c9.png";